import { useTheme } from '../../hooks/useTheme';

/**
 * Inline LIGHT · DARK · AUTO toggle for marketing footers.
 *
 * Shares styling with FooterLanguageSwitch so the two segmented controls
 * line up next to each other. Active option renders in fg, the others in
 * fg-dim — clicking sets the preference (and persists via useTheme).
 */
type Option = { code: 'light' | 'dark' | 'auto'; label: string };

const options: Option[] = [
  { code: 'light', label: 'LIGHT' },
  { code: 'dark', label: 'DARK' },
  { code: 'auto', label: 'AUTO' },
];

export default function FooterThemeSwitch() {
  const { preference, setTheme } = useTheme();
  const active: Option['code'] = preference ?? 'auto';

  return (
    <div
      role="group"
      aria-label="Theme"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontFamily: 'var(--font-mono)',
        fontSize: 12,
      }}
    >
      {options.map((opt, i) => (
        <span key={opt.code} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
          <button
            type="button"
            onClick={() => setTheme(opt.code === 'auto' ? null : opt.code)}
            aria-pressed={active === opt.code}
            style={{
              background: 'transparent',
              border: 'none',
              padding: '2px 6px',
              borderRadius: 4,
              cursor: 'pointer',
              fontFamily: 'inherit',
              fontSize: 'inherit',
              letterSpacing: '0.04em',
              color: active === opt.code ? 'var(--fg)' : 'var(--fg-dim)',
              transition: 'color 150ms',
            }}
          >
            {opt.label}
          </button>
          {i < options.length - 1 && (
            <span aria-hidden style={{ color: 'var(--border-strong)' }}>·</span>
          )}
        </span>
      ))}
    </div>
  );
}
